import { jsx as e } from "react/jsx-runtime";
function n(r) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      stroke: "rgb(var(--text-secondary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          d: "M11 1.66666V6.33333C11 8.54247 9.2091 10.3333 6.99996 10.3333C4.79082 10.3333 2.99996 8.54247 2.99996 6.33333V1.66666M1.66663 13H12.3333",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      )
    }
  );
}
export {
  n as default
};
